import React from 'react';
import '../css/SystemIntegrator.css';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import PieChart from './PieChart';
import PieChartNew from './PieChartNew';
import DoughnutChart from './DoughnutChart';
import SIProjects from './SIProjects';
import Sorting from './Sorting';
import Cookies from 'js-cookie';
import VideoView from './VideoView';
import VideoEdit from './VideoEdit';
import VideoAddNew from './VideoAddNew';
import deleteIcon from './../assets/images/delete.svg';
import SearchBar from './SearchBar';
import Style from 'style-it';
import { Tooltip } from 'react-tooltip';
import minus from './../assets/images/minus.svg';
import plus from './../assets/images/plus.svg';
import edit from './../assets/images/edit.svg';
import view from './../assets/images/view.svg';
import totalBoxes from '../assets/images/totalBoxes.svg';
import totalProjects from '../assets/images/totalProjects.svg';
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
import SiTotalOkasBoxes from './SiTotalOkasBoxes';
import Loader from './Loader';
import DistributorProjects from './DistributorProjects';
// import { red } from '@material-ui/core/colors';


//system intregator dashboard page.

const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});
class Video extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpenAddSI: false,
      modalIsOpenAddSIView: false,
      modalIsOpenSIProject: false,
      modalIsOpenOkasBoxes: false,
      modalIsOpenAddSIEdit: false,
      modalIsOpenDelete: false,
      modalIsOpenDeleteSuccess: false,
      //Distributor 
      // modalIsOpenAddDistributor: false,
      // modalIsOpenAddDistributorView: false,
      // modalIsOpenDistributorProject: false,
      // modalIsOpenOkasBoxes: false,
      // modalIsOpenAddDistributorEdit: false,
      boxesBySi: [],
      siData: [],
      actualData: [],
      searchValue: '',
      siProjectAddress: [],
      currentViewAllProjects: [],
      currentViewAllBoxes: [],
      siTotalProjectPieChart: 0,
      siTotalBoxesPieChart: 0,
      selectedLocation: '',
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      loader: true,
      snackbarActive: false,
      snackbarMessage: ''
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAddSI: false
    }, () => {
      this.setState({
        modalIsOpenAddSI: true
      })
    })
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAddSI: false });
  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }

  restoreData = (data) => {
    this.setState({
      siData: data,
    })
  }


  resetSearchBar = () => {
    this.props.searchBarActivate(false)
  }


  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.siData.sort());
            // Sorting(this.restoreData, type, this.state.actualData); 
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.siData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }



  ActivateSIModel = (e) => {
    if (this.state.modalIsOpenAddSI) {
      return <VideoAddNew activeModal={true} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  ActivateSiModelView = (e) => {
    if (this.state.modalIsOpenAddSIView) {
      return <VideoView activeModal={true} siCurrentData={this.state.siCurrentData} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  ActivateSiModelEdit = (e) => {
    if (this.state.modalIsOpenAddSIEdit) {
      return <VideoEdit activeModal={true} siCurrentData={this.state.siCurrentData} closeAllModal={this.closeAllModal.bind(this)} />
    } else {
      return null
    }
  }

  componentDidMount() {
    this.resetSearchBar()
    this.fetchDevices();
    this.fetchBoxes()
    // this.fetchLocations();
    // this.fetchAllBoxes()
  }

  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch(`/cloud/video-library/${this.state.siCurrentData.id}/`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.fetchDevices();
        this.setState({
          modalIsOpenDelete: false,
          modalIsOpenDeleteSuccess: true
        })
        console.log(this.state)
      })

      .catch((err) => {
        console.log(err)
      })
  }


  fetchDevices = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/video-library/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          siData: data,
          actualData: data,
          loader: false
        })
        // console.log(this.state.actualData)
      })
      .catch((err) => {
        console.log(err)

      })
  }

  restoreData = (data) => {
    this.setState({
      siData: data
    })
  }

  fetchBoxesBySI = (siID) => {
    let boxesBySi = [];
    this.state.okasBoxes.forEach((element) => {
      if (Number(element.okasBox_assigned_to) === Number(siID)) {
        boxesBySi.push(element)
      }
    });
    this.setState({ boxesBySi })
  }

  fetchLocations = (siId) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/all_loc_details/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ si_id: siId })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        console.log(data)
        this.setState({
          siProjectAddress: data
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }



  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.siData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.siData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }

  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  fetchRespectiveBoxes = (si_id, loc_id) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/allOkasBoxes/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: si_id,
        loc_id: loc_id
      })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          currentViewAllBoxes: data
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
  fetchAllBoxes = (si_id) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/distributor_boxes/', {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        si_id: si_id,
      })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          currentViewAllBoxes: data,
          siTotalBoxesPieChart: data.length

        })
        // console.log('data', this.state.currentViewAllBoxes)
      })
      .catch((err) => {
        console.log(err)
        // console.log(err)

      })
  }

  fetchBoxes = () => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/okasBoxApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({ forceRefresh: true })
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          okasBoxes: data
        })
      })
      .catch((err) => {
        console.log(err)

      })
  }




  selectedLocationStatus = (selectedLocation, type) => {
    if (this.state.selectedLocation === selectedLocation && type === 'location') {
      return 'bolder'
    } else if (type === 'username' && this.state.selectedLocation === '') {
      return 'bolder'
    } else {
      return 'normal'
    }
  }

  siDatatable = () => {

    if (this.state.siData !== null) {
      let someData = this.state.siData.map((siElement, index) => {
        return (
          <React.Fragment key={index}>
            <tr key={index} className="some-hover" style={{ backgroundColor: this.state.siSelected === index ? '#F2F2E9' : '' }}>

              <th scope="col" style={{ width: '20%', wordBreak: 'break-word', textAlign: 'center', verticalAlign: 'middle', wordWrap: 'break-word' }} >{index + 1}</th>
              <td
                scope="col"
                style={{
                  width: '30%',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                  wordBreak: 'break-word',
                  wordWrap: 'break-word',


                }}
              >
                {siElement.title}
              </td>

              <td scope="col" style={{ width: '30%', textAlign: 'center', verticalAlign: 'middle', wordBreak: 'break-word', wordWrap: 'break-word' }}>{siElement.description}</td>

              <td style={{ width: '20%', verticalAlign: 'middle', textAlign: 'center' }}>
                <span onClick={
                  (e) => {
                    if (this.state.modalIsOpenAddSIView) {
                      this.setState({ modalIsOpenAddSIView: false }, () => {
                        this.setState({
                          modalIsOpenAddSIView: true,
                          siCurrentData: siElement,
                          siSelected: ''
                        })
                      })
                    } else {
                      this.setState({
                        modalIsOpenAddSIView: true,
                        siCurrentData: siElement
                      })
                    }
                  }}>
                  <img src={view} alt="" style={{ width: '16px', height: '16px', marginRight: '15px' }} />
                </span>
                <span
                  onClick={
                    (e) => {
                      if (this.state.modalIsOpenAddSIEdit) {
                        this.setState({ modalIsOpenAddSIEdit: false }, () => {
                          this.setState({
                            modalIsOpenAddSIEdit: true,
                            siCurrentData: siElement,
                            siSelected: ''
                          })
                        })
                      } else {
                        this.setState({
                          modalIsOpenAddSIEdit: true,
                          siCurrentData: siElement
                        })
                      }
                    }}
                >
                  <img src={edit} alt="" style={{ width: '16px', height: '16px', marginLeft: '15px' }} />
                </span>
                <span
                  onClick={
                    (e) => {
                      if (this.state.modalIsOpenDelete) {
                        this.setState({ modalIsOpenDelete: false }, () => {
                          this.setState({
                            modalIsOpenDelete: true,
                            siCurrentData: siElement,
                            siSelected: ''
                          })
                        })
                      } else {
                        this.setState({
                          modalIsOpenDelete: true,
                          siCurrentData: siElement
                        })
                      }
                    }}
                >
                  <img src={deleteIcon} alt="" style={{ width: '16px', height: '16px', marginLeft: '25px' }} />
                </span>
              </td>
            </tr>
            {this.state.siSelected === index ? <tr style={{ overflow: 'hidden', display: this.overlayShadowUnderModal('siCurrentDataBlock') }} className="SiCurrentData animated fadeIn " >
              <td colSpan={3}>
                <div class="wrapper">
                  <ul class="StepProgress" style={{ backgroundColor: 'transparent', wordBreak: 'break-word' }}>
                    < li class="StepProgress-item is-done pointer" style={{ fontWeight: this.selectedLocationStatus('username', 'username'), float: "none" }}
                      onClick={(e) => {

                        this.setState({
                          selectedLocation: ''
                        })
                      }}>
                      <span style={{ color: '#00B0A9', fontSize: '20px', fontWeight: 'normal' }}>
                        {siElement.si_name.charAt(0).toUpperCase() + siElement.si_name.slice(1).toLowerCase()}<br />
                      </span>
                      {siElement.si_email}
                    </li>
                    {this.state.siProjectAddress.map((firstElement) => {
                      return (
                        <li
                          class="StepProgress-item is-done pointer"
                          key={firstElement}
                          style={{ fontWeight: this.selectedLocationStatus(firstElement.location, 'location'), }}
                          onClick={(e) => {
                            this.fetchProjects(siElement.si_id, firstElement.ID)
                            this.fetchRespectiveBoxes(siElement.si_id, firstElement.ID)
                            this.setState({
                              siTotalBoxesPieChart: firstElement.installed_box,
                              siTotalProjectPieChart: firstElement.project_count,
                              selectedLocation: firstElement.location
                            })
                          }}
                        >
                          {firstElement.location}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </td>
            </tr> : null}
          </React.Fragment>
        )
      })
      return someData;
    }
    else {
      return null
    }
  }

  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddSI || this.state.modalIsOpenAddSIView || this.state.modalIsOpenSIProject || this.state.modalIsOpenOkasBoxes || this.state.modalIsOpenAddSIEdit || this.state.modalIsOpenDeleteSuccess) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    } else if (type === 'siCurrentDataBlock') {
      if (this.state.modalIsOpenAddSI || this.state.modalIsOpenAddSIView || this.state.modalIsOpenSIProject || this.state.modalIsOpenOkasBoxes || this.state.modalIsOpenAddSIEdit || this.state.modalIsOpenDeleteSuccess) {
        return (
          'none'
        )
      } else {
        return null
      }
    }
  }

  closeAllModal = (e) => {
    this.fetchDevices();
    this.setState({
      modalIsOpenAddSI: false,
      modalIsOpenAddSIView: false,
      modalIsOpenSIProject: false,
      modalIsOpenOkasBoxes: false,
      modalIsOpenAddSIEdit: false,
      modalIsOpenDelete: false,
    })
  }

  render() {
    return (
      <React.Fragment>
        {this.state.loader ? <Loader /> : null}
        {this.overlayShadowUnderModal('overlay')}
        <Tooltip />
        <Style>
          {
            `.atoB {
              position: relative;
              margin:14%
            }            
            .firstDot {
              position: absolute;
              top:  ${this.state.siProjectAddress.length === 0 ? '25%' : '6%'};
              left: 0;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #949494;
            }            
            .secondDott {
              position: absolute;
              top: 70%;
              left: 0;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #949494;
            }
            .text::before {
              content: '';
              border-left: 3px solid #949494;
              width: 10px;
              position: absolute;
              height: ${this.state.siProjectAddress.length === 0 ? '0%' : '86%'};
              top: 9.5%;
              left: 1.5%;
            }            
            .text {
              margin-bottom: 20%;
              margin-left: 10%;
              color: #757575
            }            
            .heading-part1{
              font-size: 1rem;
              color: #000;
            }
            .part2{
              font-size: .75rem;
            }`
          }
        </Style>
        <div style={{ width: '100%', paddingLeft: '5px', paddingTop: '40px', paddingRight: '20px', }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>VIDEO</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <div className="pointer" onClick={this.openModal} >
                  <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                    {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                    <IconButton sx={{
                      color: '#F08100',
                      fontSize: 40,
                      backgroundColor: 'transparent',
                      '&:hover': {
                        backgroundColor: 'transparent'
                      },
                      '&:focus': {
                        outline: 'none',
                        border: 'none',
                        backgroundColor: 'transparent'
                      }
                    }} aria-label="add">
                      <AddIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                    <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>ADD VIDEO</span>
                  </div>
                </div>
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
            <SearchBar autoFocus
              value={this.state.searchValue}
              onChange={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', this.state.searchValue)
                })
              }
              }
              onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
              resetSearch={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', '')
                })
              }}
            /></div>}
          <table className="table">
            <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px', fontSize:'12px' }}>
              {/* <th scope="col" style={{ width: '1px' }}></th> */}
              <th scope="col" style={{ width: '20%', verticalAlign: 'middle', textAlign: 'center' }}>
                ID
                {/* <i class={this.fetchIconType('si_id')} onClick={(e) => { this.sortingFunc('si_id') }}></i> */}
              </th>
              <th scope="col" style={{ width: '30%', verticalAlign: 'middle', textAlign: 'center' }}>
                Title
                {/* <i class={this.fetchIconType('si_name')} onClick={(e) => { this.sortingFunc('si_name') }}></i> */}
              </th>
              <th scope="col" style={{ width: '30%', verticalAlign: 'middle', textAlign: 'center' }}>
                Description
                {/* <i class={this.fetchIconType('si_company')} onClick={(e) => { this.sortingFunc('si_company') }}></i> */}
              </th>
              <th scope="col" style={{ width: '20%', verticalAlign: 'middle', textAlign: 'center' }}>
                View | Edit | Delete
              </th>
            </thead>
            <tbody style={{ maxHeight: `${window.innerHeight - 250}px`, overflowY: 'overlay',fontSize:'12px' }}>
              {this.siDatatable()}
            </tbody>
          </table>
        </div>
        {this.ActivateSIModel()}
        {this.ActivateSiModelView()}
        {this.ActivateSiModelEdit()}
        {/* {this.renderTotalProject()} */}
        {/* {this.renderTotalBoxes()} */}
        <div className="modal">
          <DoughnutChart />
        </div>
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure you want to proceed with deletion?</h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.onDeleteFinal.bind(this)}>Delete </div>
          </div>
        </Modal>


        <Modal
          isOpen={this.state.modalIsOpenDeleteSuccess}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times"
              onClick={() => {
                this.setState({
                  modalIsOpenDeleteSuccess: false
                })

              }}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Video deleted successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            {/* <div className="btn reset-btn mx-2 px-5"
             onClick={() => {
              this.setState({
                modalIsOpenDeleteSuccess: false
              })
        
            }}></div> */}
          </div>

          {/* Add setTimeout to close the modal after a specified time (e.g., 20000 milliseconds) */}
          {setTimeout(() => {
            this.setState({
              modalIsOpenDeleteSuccess: false
            });
          }, 10000)}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Video);